import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon } from 'lucide-react';
import type { Case } from '../../../types/admin';
import { StatusBadge } from '../StatusBadge';
import { StartTimerButton } from '../timer/StartTimerButton';
import { relativeUpcoming } from '../../../utils/adminDates';
interface ActiveCaseCardProps {
  caseItem: Case;
  onRegisterHours: (item: Case) => void;
}
export function ActiveCaseCard({
  caseItem,
  onRegisterHours
}: ActiveCaseCardProps) {
  return <li className="rounded-card border border-line bg-white p-4" data-id="element-661" data-mp="tvq3nvu8s8zn">
      <div className="flex items-start justify-between gap-3" data-id="element-662" data-mp="ttcbbuqy5avs">
        <div className="min-w-0" data-id="element-663" data-mp="18jbao0u8mscu">
          <Link to={`/admin/sager/${caseItem.id}`} className="block truncate text-[16px] font-semibold text-ink hover:underline" data-id="element-664" data-mp="18mfhz730247q">
            {caseItem.title}
          </Link>
          <p className="truncate text-sm text-ink-soft" data-id="element-665" data-mp="1hlkgweih3zkf">{caseItem.customerName}</p>
          {caseItem.address && <p className="truncate text-sm text-ink-muted" data-id="element-666" data-mp="1cnj0k1cfmecn">{caseItem.address}</p>}
          <p className="mt-0.5 text-sm text-ink-muted" data-id="element-667" data-mp="3ku7fubkq6wv0">{relativeUpcoming(caseItem.plannedDate)}</p>
        </div>
        <StatusBadge status={caseItem.status} data-id="element-668" data-mp="3psr62o6cqut6" />
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-669" data-mp="3uqsp593s2u4n">
        <StartTimerButton caseItem={caseItem} data-id="element-670" data-mp="3uton2xfmlit3" />
        <button type="button" onClick={() => onRegisterHours(caseItem)} className="inline-flex h-11 items-center justify-center gap-1.5 whitespace-nowrap rounded-full border border-line px-3 text-sm font-medium text-ink transition-colors duration-150 hover:border-ink/30" data-id="element-671" data-mp="3laprzivdsol">
          <ClockIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-672" data-mp="hdqo4n0tt2j6" />
          Registrér timer
        </button>
        <Link to={`/admin/sager/${caseItem.id}`} className="col-span-2 inline-flex h-11 items-center justify-center whitespace-nowrap rounded-full border border-line px-3 text-sm font-medium text-ink-soft transition-colors duration-150 hover:border-ink/30 hover:text-ink sm:col-span-1" data-id="element-673" data-mp="maz9sxl6nop6">
          Åbn sag
        </Link>
      </div>
    </li>;
}